const STORAGE_PREFIX = 'synap_chunk_reload_v1_'

export const chunkReloadStorageKey = (release: string): string =>
  `${STORAGE_PREFIX}${release.trim() || 'unknown'}`

/**
 * Uma recarga por release por aba — evita loop após deploy com chunk stale.
 * Retorna true se disparou reload.
 */
export type ChunkReloadOptions = {
  /** Só para testes — evita `location.reload()` real no Playwright. */
  reload?: () => void
}

export const tryOneTimeChunkReload = (release: string, options?: ChunkReloadOptions): boolean => {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return false
  const key = chunkReloadStorageKey(release)
  if (sessionStorage.getItem(key)) return false
  sessionStorage.setItem(key, String(Date.now()))
  const reload = options?.reload ?? (() => window.location.reload())
  reload()
  return true
}
